export default __webpack_public_path__ + "static/media/8s.9ad41a45.png";